module.exports = __webpack_public_path__ + "static/media/BGHotQuestion2.9e05c6c5.svg";